jQuery(function ($) {

  ////////////////////////////////////
  /// object-fit用
  ////////////////////////////////////

  if (typeof objectFitImages === 'function') {
    objectFitImages();
  }

});